<script>
  export default {
    data() {
      return {
        list: [
          {
            title: '公司簡介',
            name: 'about-zerone'
          },
          {
            title: '經營團隊',
            name: 'about-organization'
          },
          {
            title: '大事紀',
            name: 'about-history'
          },
        ],
      }
    }
  }
</script>
<template>
  <BaseLayout
    :menu-list="list"
    :img="require('@assets/images/about/banner.png')"
    custom-class="isStyleWhite"
  >
    <slot/>
  </BaseLayout>
</template>
<style lang="scss" module>

</style>
